module.exports = __webpack_public_path__ + "static/media/parking_none.b604ffbc.svg";